<template>
	<div class="list" :style="{ marginTop: data.marginTop + 'px', paddingTop: data.paddingTop + 'px' }">
		<div :class="[is_web_css, data.bookLink_fixed]">
			<img v-if="data.data.length > 0" :src="data.data[0]" class="top" @click="toHref()" :style="{ paddingLeft: data.paddingLeft + '%', paddingRight: data.paddingRight + '%' }" />
			<img v-else src="../../assets/img/ly/index_6.png" class="top" />
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
import axios from 'axios';
export default {
	name: 'bookLink_fixed',
	props: ['data', 'className'],
	data() {
		return {
			toHrefJson: {},
			is_web_css: '',
		};
	},

	mounted() {
		if (!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
			this.is_web_css = 'is_web_css';
		}
		if (this.data.targetAddress != '' && this.data.targetBook != '') {
			this.getActivityInfo();
		}
	},
	methods: {
		//获取活动的信息
		getActivityInfo() {
			var url = process.env.VUE_APP_BASE_API + '/act/page/listH5';
			axios.get(url, { params: { aiId: this.data.aiId }, headers: { Authorization: 'Bearer ' + this.data.token, clientOs: 'h5' } }).then((res) => {
				if (res.data.code != 200) return false;
				if (res.data.rows.length <= 0) return false;
				var newJson = {};
				res.data.rows.map((e) => {
					if (e.apName == '书架') newJson['bookshelf'] = e.apId;
					if (e.abId == this.data.targetBook) {
						if (e.apName == '书籍介绍落地页') newJson['bookIntroduction'] = e.apId;
						if (e.apName == '课程介绍落地页') newJson['courseIntroduction'] = e.apId;
					}
				});
				this.toHrefJson = newJson;
			});
		},
		//跳转
		toHref() {
			if (this.data.targetAddress == '1') {
				//书架
				if (this.toHrefJson.bookshelf == undefined) {
					Toast('此活动没有书架页面！');
					return false;
				}
				this.$router.push('H5Page?id=' + this.toHrefJson.bookshelf);
			} else if (this.data.targetAddress == '2') {
				//书籍落地页
				if (this.toHrefJson.bookIntroduction == undefined) {
					Toast('未配置书籍介绍页');
					return false;
				}
				this.$router.push('H5Page?id=' + this.toHrefJson.bookIntroduction);
			} else if (this.data.targetAddress == '3') {
				//课程介绍落地页
				if (this.toHrefJson.courseIntroduction == undefined) {
					Toast('未配置课程介绍页');
					return false;
				}
				this.$router.push('H5Page?id=' + this.toHrefJson.courseIntroduction);
			} else if (this.data.targetAddress == '4') {
				//书籍详情页
				if (this.data.targetBook == undefined) {
					Toast('未配置书籍详情页');
					return false;
				}
				location.href = './booktop.html?abId=' + this.data.targetBook + '&token=' + this.data.token;
			}
		},
	},
};
</script>

<style scoped>
.top {
	display: block;
	width: 100%;
}
</style>